module.exports = {
    extends: [
        '/',
        'templates',
        'core',
        'form',
        'form',
    ],

    config: {
        isFullyVertical: false,
        isFullyHorizontal: true,
        resourceConnected: false,
    },

    methods: {
        /**
         * this function will be called after the form values has been changed.
         *
         * @param isRelationChange 		boolean - was the change related to a relation or not
         * @param changeDone 			boolean - has a change been done
         * @param fieldData 			{} - fieldData used to define what to do
         */
        onChange: function(isRelationChange, changeDone, fieldData){
            // NOTE: this function can be overwritten by inherited form components if needed
            const options = (this.model.dirtyFields.data || {}).attributes || {}
            this.triggerClosest('controlsOptionsChanged', { options }, 'templates_crew_employeeReports_controller')
        },
    }
}